import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65eaf9d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "zygcfxselect" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 报告期 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("营业收入")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("营业成本")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("利润比例")
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "按行业分")
], -1))
const _hoisted_9 = { class: "ybtitle-tooltip" }
const _hoisted_10 = ["onMouseleave", "onMouseenter"]
const _hoisted_11 = {
  key: 2,
  style: {"height":"150px","margin-left":"-16px"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "按产品分")
], -1))
const _hoisted_13 = { class: "ybtitle-tooltip" }
const _hoisted_14 = ["onMouseleave", "onMouseenter"]
const _hoisted_15 = {
  key: 2,
  style: {"height":"150px","margin-left":"-16px"}
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "按地区分")
], -1))
const _hoisted_17 = { class: "ybtitle-tooltip" }
const _hoisted_18 = ["onMouseleave", "onMouseenter"]
const _hoisted_19 = {
  key: 2,
  style: {"height":"150px","margin-left":"-16px"}
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_Charts = _resolveComponent("Charts")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_Table = _resolveComponent("Table")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    tip: "加载中...",
    spinning: _ctx.spinning
  }, {
    default: _withCtx(() => [
      ((_ctx.data || []).length)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_a_select, {
                value: _ctx.value1,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value1) = $event)),
                style: {"width":"120px"},
                onChange: _ctx.handleChange,
                size: "small",
                getPopupContainer: _ctx.getPopupContainer
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectoptions, (item, i) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item,
                      key: 'zygcfx' + i
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.moment(item * 1000).format('YYYY-MM-DD')), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "onChange", "getPopupContainer"])
            ]),
            _createVNode(_component_a_radio_group, {
              value: _ctx.activeKey,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeKey) = $event)),
              "button-style": "solid",
              onChange: _ctx.changetab
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_button, { value: "OperatingReenue" }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_radio_button, { value: "OperCost" }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_radio_button, { value: "MainprofitReenue" }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value", "onChange"]),
            ((_ctx.handerlegend1 || []).length || (_ctx.handerlegend2 || []).length || (_ctx.handerlegend3 || []).length)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                  _createElementVNode("li", null, [
                    _hoisted_8,
                    ((_ctx.handerlegend1 || []).length)
                      ? (_openBlock(), _createBlock(_component_Charts, {
                          key: 0,
                          id: "yysr1",
                          option: _ctx.option1
                        }, null, 8, ["option"]))
                      : _createCommentVNode("", true),
                    ((_ctx.handerlegend1 || []).length)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(["sdltgdchartslist", {'cencelcenter': _ctx.handerlegend1.length >5}])
                        }, [
                          _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.handerlegend1 || []), (item, i) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: 'zygcfxli' + i
                              }, [
                                _createElementVNode("i", {
                                  style: _normalizeStyle({'background-color': _ctx.color[i - Math.floor(i/10)*10]})
                                }, null, 4),
                                _createVNode(_component_a_tooltip, {
                                  placement: "topLeft",
                                  visible: _ctx.overflow[item.index],
                                  align: {
                offset: [0, 4],
                },
                                  destroyTooltipOnHide: "",
                                  mouseEnterDelay: 0.4,
                                  getPopupContainer: _ctx.getPopupContainer
                                }, {
                                  title: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_9, _toDisplayString(item.Project), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("span", {
                                      class: "overflow",
                                      onMouseleave: _withModifiers(($event: any) => (_ctx.hidetool(item, i)), ["stop"]),
                                      onMouseenter: _withModifiers(($event: any) => (_ctx.isoverflow(item, $event)), ["stop"]),
                                      href: "javascript:void(0)"
                                    }, _toDisplayString(item.Project ? item.Project : '—'), 41, _hoisted_10)
                                  ]),
                                  _: 2
                                }, 1032, ["visible", "mouseEnterDelay", "getPopupContainer"])
                              ]))
                            }), 128))
                          ])
                        ], 2))
                      : (_openBlock(), _createElementBlock("section", _hoisted_11, [
                          _createVNode(_component_Nodata, {
                            mode: "vertical",
                            customdesc: '暂无数据'
                          })
                        ]))
                  ]),
                  _createElementVNode("li", null, [
                    _hoisted_12,
                    ((_ctx.handerlegend2 || []).length)
                      ? (_openBlock(), _createBlock(_component_Charts, {
                          key: 0,
                          id: "yysr2",
                          option: _ctx.option2
                        }, null, 8, ["option"]))
                      : _createCommentVNode("", true),
                    ((_ctx.handerlegend2 || []).length)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(["sdltgdchartslist", {'cencelcenter': _ctx.handerlegend2.length >5}])
                        }, [
                          _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.handerlegend2 || []), (item, i) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: 'zygcfxli2' + i
                              }, [
                                _createElementVNode("i", {
                                  style: _normalizeStyle({'background-color': _ctx.color[i - Math.floor(i/10)*10]})
                                }, null, 4),
                                _createVNode(_component_a_tooltip, {
                                  placement: "topLeft",
                                  visible: _ctx.overflow[item.index],
                                  align: {
                offset: [0, 4],
                },
                                  destroyTooltipOnHide: "",
                                  mouseEnterDelay: 0.4,
                                  getPopupContainer: _ctx.getPopupContainer
                                }, {
                                  title: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_13, _toDisplayString(item.Project), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("span", {
                                      class: "overflow",
                                      onMouseleave: _withModifiers(($event: any) => (_ctx.hidetool(item, i)), ["stop"]),
                                      onMouseenter: _withModifiers(($event: any) => (_ctx.isoverflow(item, $event)), ["stop"]),
                                      href: "javascript:void(0)"
                                    }, _toDisplayString(item.Project ? item.Project : '—'), 41, _hoisted_14)
                                  ]),
                                  _: 2
                                }, 1032, ["visible", "mouseEnterDelay", "getPopupContainer"])
                              ]))
                            }), 128))
                          ])
                        ], 2))
                      : (_openBlock(), _createElementBlock("section", _hoisted_15, [
                          _createVNode(_component_Nodata, {
                            mode: "vertical",
                            customdesc: '暂无数据'
                          })
                        ]))
                  ]),
                  _createElementVNode("li", null, [
                    _hoisted_16,
                    ((_ctx.handerlegend3 || []).length)
                      ? (_openBlock(), _createBlock(_component_Charts, {
                          key: 0,
                          id: "yysr3",
                          option: _ctx.option3
                        }, null, 8, ["option"]))
                      : _createCommentVNode("", true),
                    ((_ctx.handerlegend3 || []).length)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(["sdltgdchartslist", {'cencelcenter': _ctx.handerlegend3.length >5}])
                        }, [
                          _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.handerlegend3 || []), (item, i) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: 'zygcfxli3' + i
                              }, [
                                _createElementVNode("i", {
                                  style: _normalizeStyle({'background-color': _ctx.color[i - Math.floor(i/10)*10]})
                                }, null, 4),
                                _createVNode(_component_a_tooltip, {
                                  placement: "topLeft",
                                  visible: _ctx.overflow[item.index],
                                  align: {
                offset: [0, 4],
                },
                                  destroyTooltipOnHide: "",
                                  mouseEnterDelay: 0.4,
                                  getPopupContainer: _ctx.getPopupContainer
                                }, {
                                  title: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_17, _toDisplayString(item.Project), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("span", {
                                      class: "overflow",
                                      onMouseleave: _withModifiers(($event: any) => (_ctx.hidetool(item, i)), ["stop"]),
                                      onMouseenter: _withModifiers(($event: any) => (_ctx.isoverflow(item, $event)), ["stop"]),
                                      href: "javascript:void(0)"
                                    }, _toDisplayString(item.Project ? item.Project : '—'), 41, _hoisted_18)
                                  ]),
                                  _: 2
                                }, 1032, ["visible", "mouseEnterDelay", "getPopupContainer"])
                              ]))
                            }), 128))
                          ])
                        ], 2))
                      : (_openBlock(), _createElementBlock("section", _hoisted_19, [
                          _createVNode(_component_Nodata, {
                            mode: "vertical",
                            customdesc: '暂无数据'
                          })
                        ]))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("ul", _hoisted_20, [
                  _createVNode(_component_Nodata, {
                    mode: "vertical",
                    customdesc: '暂无数据'
                  })
                ])),
            _createElementVNode("div", null, [
              _createVNode(_component_Table, {
                data: _ctx.data,
                columns: _ctx.columns,
                bordered: true,
                pagination: false
              }, null, 8, ["data", "columns"])
            ])
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_21, [
            _createVNode(_component_Nodata, {
              nodatadesc: _ctx.itemdata.title
            }, null, 8, ["nodatadesc"])
          ]))
    ]),
    _: 1
  }, 8, ["spinning"]))
}